import { FastForward } from '@styled-icons/boxicons-regular';
import { DreamValue, TextLeaf } from '@typedream/core';
import { PlateRenderLeafProps } from '@udecode/plate-core';

function AnimatedTextLeaf(
  props: PlateRenderLeafProps<DreamValue, TextLeaf>,
) {
  const { attributes, children, leaf } = props;

  return (
    <span
      {...attributes}
      style={{
        fontSize: leaf?.fontSize,
        lineHeight: leaf?.lineHeight,
        ...(leaf?.animation?.type ? {
          backgroundColor: 'var(--highlight-2)',
          border: '1px solid var(--border-modal-transparent)',
          borderRadius: 2,
        } : {}),
      }}
    >
      {leaf?.animation?.type && (
      <FastForward
        size={18}
        style={{
          color: 'var(--text-on-accent)',
          background: 'var(--accent)',
          border: '1px solid var(--border-modal)',
          borderRadius: '50%',
          boxShadow: 'var(--shadow-modal)',
          userSelect: 'none',
          verticalAlign: 'middle',
        }}
      />
      )}

      {children}
    </span>
  );
}

export default AnimatedTextLeaf;
